export default {
  computed: {
    currentAdmin() {
      return this.$store.state.app.currentAdmin
    },
    currentServiceProvider() {
      return this.$store.state.app.currentServiceProvider
    },
    /**
     * 是否根运营商
     *
     * @returns {boolean} 是否根运营商
     */
    isRootServiceProvider() {
      if (this.currentServiceProvider.id) {
        return this.currentServiceProvider.node_path.split('/').length === 2
      } else {
        return false
      }
    }
  }
}
